export default "__VITE_ASSET__C6c$_juZ__"